import locale from '~/utils/locale'

export default locale.create<{
    selectedPaymentsLabel: (paymentCount: number, amountsByCurrencies: React.ReactNode) => JSX.Element,
    clearButton: string
}>()
